import { isEmpty, isEqual } from 'lodash';

export function isTrueAll(parameters: string[] = [], condition: string) {
  return parameters.every((item) => item == condition);
}

export function isOneConditionTrue(
  firstParam: string,
  secondParam: string,
  condition: string
) {
  return firstParam !== condition && secondParam === condition;
}

export function isFalseAll(parameters: string[] = [], condition: string) {
  return parameters.every((item) => item !== condition);
}

export function isArrayNotEmpty(array: string[] = [], arrayLength: number) {
  return !isEmpty(array) && !isEqual(arrayLength, 1);
}
